/**
 * @file Recalls system-note content display helpers.
 */

/**
 * Converts stored YYYY-MM-DD dates in Recalls system-note copy to DD/MM/YYYY.
 * @param {string} content Stored note content.
 * @returns {string} Display content.
 */
export function formatRecallsSystemNoteContent(content = "") {
    return String(content || "").replace(
        /\b(\d{4})-(\d{2})-(\d{2})\b/g,
        (_match, year, month, day) => `${day}/${month}/${year}`,
    );
}
